<template>

<div class="mbh-decision" v-if="data">

	<div class="mbh-decision-intro" v-if="data.intro" v-html="data.intro"></div>

	<div class="mbh-decision-scale">

		<div class="mbh-decision-scale-label">{{ data.benefits && data.benefits.title || 'How important are these medicine benefits to you?' }}</div>

		<div class="mbh-decision-scale-row is-header">
			<div class="mbh-decision-scale-item"></div>
			<div class="mbh-decision-scale-item" v-for="col in columns" :key="'bh-' + col">{{ col }}</div>
		</div>

		<div class="mbh-decision-scale-row" v-for="(row, ri) in benefits" :key="'b-' + ri">
			<div class="mbh-decision-scale-item is-text">{{ row }}</div>
			<div class="mbh-decision-scale-item" v-for="(col, ci) in columns" :key="'bc-' + ri + ci">
				<div class="mbh-decision-scale-check" :class="{'is-active': benefitValues[ri] === ci}" v-on:click="$set(benefitValues, ri, ci)"></div>
			</div>
		</div>

	</div>

	<div class="mbh-decision-scale">

		<div class="mbh-decision-scale-label">{{ data.concerns && data.concerns.title || 'How concerned are you about...' }}</div>

		<div class="mbh-decision-scale-row is-header">
			<div class="mbh-decision-scale-item"></div>
			<div class="mbh-decision-scale-item" v-for="col in columns" :key="'ch-' + col">{{ col }}</div>
		</div>

		<div class="mbh-decision-scale-row" v-for="(row, ri) in concerns" :key="'c-' + ri">
			<div class="mbh-decision-scale-item is-text">{{ row }}</div>
			<div class="mbh-decision-scale-item" v-for="(col, ci) in columns" :key="'cc-' + ri + ci">
				<div class="mbh-decision-scale-check" :class="{'is-active': concernValues[ri] === ci}" v-on:click="$set(concernValues, ri, ci)"></div>
			</div>
		</div>

	</div>

	<div class="mbh-decision-foot">
		<button class="mbh-save-button" :class="{'is-disabled': !hasAnswers}" v-on:click="hasAnswers && onSave()">Save</button>
	</div>

</div>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {
			columns: ['Not at all', 'Slightly', 'Moderately', 'Very', 'Extremely'],
			benefitValues: {},
			concernValues: {}
		}

	},

	created: function() {

		var saved = localStorage.getItem('ifrap_patient_decision')
		if (saved) {
			var parsed = JSON.parse(saved)
			this.benefitValues = parsed.benefits || {}
			this.concernValues = parsed.concerns || {}
			if (this.isComplete) this.$emit('complete')
		}

	},

	computed: {

		benefits: function() {

			return (this.data.benefits && this.data.benefits.rows) ? this.$_.filter(this.data.benefits.rows, function(r) { return r }) : []

		},

		concerns: function() {

			return (this.data.concerns && this.data.concerns.rows) ? this.$_.filter(this.data.concerns.rows, function(r) { return r }) : []

		},

		hasAnswers: function() {

			return Object.keys(this.benefitValues).length > 0 || Object.keys(this.concernValues).length > 0

		},

		isComplete: function() {

			var bCount = Object.keys(this.benefitValues).length
			var cCount = Object.keys(this.concernValues).length

			return bCount >= this.benefits.length && cCount >= this.concerns.length && this.benefits.length > 0

		}

	},

	watch: {

		isComplete: function(val) {

			if (val) this.$emit('complete')

		}

	},

	methods: {

		onSave: function() {

			localStorage.setItem('ifrap_patient_decision', JSON.stringify({
				benefits: this.benefitValues,
				concerns: this.concernValues
			}))
			if (this.isComplete) this.$emit('complete')
			this.$emit('close')

		}

	}

}

</script>

<style>

.mbh-decision-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 32px; font-weight: 300; }

.mbh-decision-scale { margin-bottom: 40px; }

.mbh-decision-scale-label {
	font-size: 18px;
	font-weight: 600;
	color: #343434;
	margin-bottom: 16px;
}

.mbh-decision-scale-row {
	display: grid;
	grid-template-columns: auto 80px 80px 80px 80px 80px;
}

.mbh-decision-scale-row.is-header .mbh-decision-scale-item {
	font-size: 12px;
	font-weight: 600;
	color: #888;
	text-transform: uppercase;
}

.mbh-decision-scale-item {
	height: 48px;
	font-size: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.mbh-decision-scale-item.is-text {
	justify-content: flex-start;
	text-align: left;
	color: #343434;
}

.mbh-decision-scale-check {
	width: 24px;
	height: 24px;
	border: 2px solid #eee;
	border-radius: 4px;
	cursor: pointer;
	background-color: #fff;
}

.mbh-decision-scale-check:hover {
	border-color: #ccc;
}

.mbh-decision-scale-check.is-active {
	background-color: #343434;
	border-color: #343434;
}

.mbh-decision-foot { display: flex; justify-content: center; margin-top: 16px; }

</style>
